export class PlayerGameData {
}
